import React, { useState, useRef, useLayoutEffect, useEffect } from 'react'
import styled from 'styled-components'
import { NavLink as RouterNavLink } from 'react-router-dom'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ImgImp from '../assets/a-propos-multiverse.png'
import LogoImg from '../assets/logo.png'
import Bannerr from '../assets/banner-apropos.png'
import BurgerImg from '../assets/Burger.svg'

gsap.registerPlugin(ScrollTrigger)

const NavbarContainer = styled.nav`
  width: 100%;
  padding: 0 2rem;
  height: 60px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: relative;
  background: #000;
  @media (max-width: 900px) {
    grid-template-columns: auto 1fr auto;
  }
`

const LogoWrapper = styled(RouterNavLink)`
  justify-self: start;
  display: flex;
  align-items: center;
`

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  grid-column: 2;
  @media (max-width: 900px) {
    display: none;
  }
`

const StyledNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-family: 'PoppinsMedium';
  color: #fff;
  font-weight: 500;
  transition: color 0.2s;
`

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;
  grid-column: 3;
  @media (max-width: 900px) {
    display: none;
  }
`

const LanguageButton = styled.button`
  background: none;
  border: none;
  font-size: 0.9rem;
  color: #fff;
  cursor: pointer;
  font-family: 'PoppinsMedium';
`

const DiscoverButton = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  text-decoration:none;
  color: #000;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
`

const BurgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  @media (max-width: 900px) {
    display: block;
    justify-self: end;
  }
`

const BurgerIcon = styled.img`
  width: 30px;
  height: auto;
`

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  z-index: 5;
`

const MobileMenu = styled.div`
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: rgba(0,0,0,0.5);
  z-index: 6;

  a, button {
    color: #fff;
    font-size: 1.2rem;
  }
  ${DiscoverButton} {
    background: #fff;
    color: #000;
  }
`

const PageContainer = styled.div`
  background-color: #000;
  color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 5rem;
`

const SectionOne = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 4rem;
`

const SubtitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  height: 22px;
  @media (max-width: 900px) {
    height: 60px;
  }
`
const TitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  height: 125px;
  @media only screen
  and (min-device-width: 760px)
  and (max-device-width: 1024px) {
    height: 110px;
  }
  @media (max-width: 760px) {
    height: 185px;
  }
  
`

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
  @media (max-width: 900px) {
    font-size: 6rem;
    text-align: center;
    margin-bottom:1rem;
  }
  @media (max-width: 410px) {
    font-size: 5rem;
    text-align: center;
    margin-bottom:1rem;
  }
  
`

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin: 0;
  margin-bottom: 1rem;
  @media (max-width: 900px) {
    font-size: 1rem;
    text-align: center;
  }
`

const SubtitleButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5rem;
  margin-top: 5%;
  @media (max-width: 900px) {
    flex-direction: column;
    margin-top: 0%;
    gap: 0rem;
  }
`

const Button = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  text-decoration:none;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  color: #000;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
    @media (max-width: 900px) {
  }
`

const Banner = styled.div`
  width: 100%;
  height: 70vh;
  margin-bottom: 2rem;
  background-image: url(${Bannerr});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: 900px) {
    height: 40vh;
  }
`

const Spacer = styled.div`
  height: 2rem;
`

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap:40px;
  justify-content: space-between;
  margin-left: 5%;
  padding-top: 5%;
  @media (min-width: 1500px) {
    width: 100%;
    justify-content: center;
    gap:100px;
  }
  @media only screen
  and (min-device-width: 760px)
  and (max-device-width: 1024px) {
    justify-content: center;
    flex-direction: column;
    align-items:center;
    margin-left: 0;
    gap:0px;
}
  @media (max-width: 760px) {
    flex-direction: column;
    width: 100%;
    margin-left: 0;
    padding-top: 10%;
    gap:0px;
    justify-content: center;
  }

`

const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;

  @media (max-width: 900px) {
    padding: 2rem;
  }
`

const ContentImage = styled.img`
  width: 350px;
  @media (max-width: 900px) {
    width: 200px;
    margin-top:-15%;
  }
`

const ContentSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #ccc;
  width: 90%;
  @media (max-width: 900px) {
    margin-top:-10%;
  }
`

const Title2 = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
  @media (max-width: 900px) {
    display: none;
  }
`

const Title3 = styled.p`
  display: none;
  @media (max-width: 900px) {
    display: block;
    font-size: 5rem;
    color: #fff;
    font-family: 'MongoGrotesqueLight';
    margin: 0 0 10% 0;
    text-align: center;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const BulletItem = styled.li`
  position: relative;
  padding-left: 2rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #ccc;
  
  &::before {
    content: '→';
    position: absolute;
    left: 0;
    color: #fff;
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  /* Alternative bullet styles - uncomment one: */
  /* Diamond style */
  /* &::before {
    content: '◆';
    position: absolute;
    left: 0;
    color: #fff;
    font-size: 0.9rem;
  } */
  
  /* Arrow with shadow */
  /* &::before {
    content: '▶';
    position: absolute;
    left: 0;
    color: #fff;
    font-size: 0.8rem;
  } */
`

const AboutIntro: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  const subtitleRef = useRef<HTMLParagraphElement>(null)
  const titleRef    = useRef<HTMLParagraphElement>(null)
  const bottomTitle3Ref = useRef<HTMLParagraphElement>(null)
  const bottomTitle2Ref = useRef<HTMLParagraphElement>(null)

  const [isMobile, setIsMobile] = useState(window.innerWidth < 900)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useLayoutEffect(() => {
    if (subtitleRef.current && titleRef.current) {
      gsap.set([subtitleRef.current, titleRef.current], { yPercent: 100 })
      const tl = gsap.timeline({ delay: 0 })
      tl.to(subtitleRef.current, {
        yPercent: 0,
        duration: 1,
        ease: 'power4.out',
      })
      .to(titleRef.current, {
        yPercent: 0,
        duration: 1,
        ease: 'power4.out',
      }, '-=0.3')
    }

    const elems = [bottomTitle3Ref.current, bottomTitle2Ref.current].filter(Boolean) as Element[]

    gsap.fromTo(elems,
      { yPercent: 100, opacity: 0 },
      {
        yPercent: 0,
        opacity: 1,
        duration: 1,
        ease: 'power4.out',
        stagger: 0.2,
        scrollTrigger: {
          trigger: elems[0],
          start: isMobile ? 'top 95%' : 'top 90%',
          toggleActions: 'play none none none',
        },
      }
    )
  }, [isMobile])

  return (
    <PageContainer>
      <NavbarContainer>
        <LogoWrapper to="/"><Logo src={LogoImg} alt="Logo" /></LogoWrapper>
        <NavLinks>
          <StyledNavLink to="/aboutus">À PROPOS DE NOUS</StyledNavLink>
          <StyledNavLink to="/jockerclub">JOKER CLUB</StyledNavLink>
          <StyledNavLink to="/">MULTISHOP</StyledNavLink>
          <StyledNavLink to="/contactus">CONTACT</StyledNavLink>
        </NavLinks>
        <RightActions>
      {/*<LanguageButton>ENG</LanguageButton>*/}
          <DiscoverButton>JE DÉCOUVRE</DiscoverButton>
        </RightActions>
        <BurgerButton onClick={() => setIsOpen(!isOpen)}>
          <BurgerIcon src={BurgerImg} alt="Menu" />
        </BurgerButton>
      </NavbarContainer>

      {isOpen && (
        <>
          <Overlay onClick={() => setIsOpen(false)} />
          <MobileMenu>
            <StyledNavLink to="/aboutus" onClick={() => setIsOpen(false)}>
              À PROPOS DE NOUS
            </StyledNavLink>
            <StyledNavLink to="/jockerclub" onClick={() => setIsOpen(false)}>
              JOKER CLUB
            </StyledNavLink>
            <StyledNavLink to="/" onClick={() => setIsOpen(false)}>
              MULTISHOP
            </StyledNavLink>
            <StyledNavLink to="/contactus" onClick={() => setIsOpen(false)}>
            CONTACTEZ-NOUS
          </StyledNavLink>
            {/*  <LanguageButton onClick={() => setIsOpen(false)}>ENG</LanguageButton>*/}
          
            <DiscoverButton onClick={() => setIsOpen(false)}>JE DÉCOUVRE</DiscoverButton>
          </MobileMenu>
        </>
      )}

      <SectionOne>
        <TitleWrapper>
          <Title ref={titleRef}>À PROPOS DE NOUS</Title>
        </TitleWrapper>
        <SubtitleButtonRow>
          <SubtitleWrapper>
            <Subtitle ref={subtitleRef}>Inventez le futur du divertissement.</Subtitle>
          </SubtitleWrapper>
          <Button>LIEN OFFICIEL</Button>
        </SubtitleButtonRow>
      </SectionOne>

      <Banner />
      <Spacer />

      <ContentRow>
        <Title3 ref={bottomTitle3Ref}>NOTRE PHILOSOPHIE</Title3>
        <ContentImage src={ImgImp} alt="Illustration" />
        <ContentCard>
          <Title2 ref={bottomTitle2Ref}>NOTRE PHILOSOPHIE</Title2>
          <ContentSubtitle>
            Partouche Multiverse est la filiale innovation du Groupe Partouche créée en<br />  2022.<br /> <br /> 
            Nous explorons les nouvelles formes de divertissement à travers le digital, <br /> le gaming, l’immersion et les technologies émergentes, pour imaginer les <br /> usages de demain :<br /> <br /> 

            <BulletList>
              <BulletItem>
                <strong>Développement :</strong> Accélérer la transformation digitale du Groupe Partouche
              </BulletItem>
              <BulletItem>
                <strong>Innovation :</strong> Diversifier l'offre de divertissement avec des expériences et projets innovants
              </BulletItem>
              <BulletItem>
                <strong>Vision :</strong> S'appuyer sur une conviction forte : la révolution numérique redéfinit les attentes des consommateurs.
              </BulletItem>
            </BulletList>
            <br />
            Partouche Multiverse relie l'héritage du jeu à l'innovation, avec une vision <br /> résolument tournée vers l'avenir.
          </ContentSubtitle>
        </ContentCard>
      </ContentRow>
    </PageContainer>
  )
}

export default AboutIntro